/* =============================================================================
 * Livly — Country & Language popup
 * ===========================================================================*/

(function () {
  'use strict';

  // ---------- CONFIGURE ------------------------------------------------------
  var COOKIE_NAME = 'livly_locale_seen';
  var COOKIE_DAYS = 180;

  var LANGIFY_MODE   = 'auto';
  var LANGIFY_PARAM  = 'lang';
  var LANGIFY_DOMAINS = {};

  // Country → allowed languages.
  // English is included intentionally as fallback for each local market.
  var COUNTRY_LANGUAGE_MAP = {
    SE: ['sv', 'en'],
    DK: ['da', 'en'],
    NO: ['nb', 'no', 'en'],
    FI: ['fi', 'en'],
    DE: ['de', 'en'],
    FR: ['fr', 'en'],
    NL: ['nl', 'en'],
    PL: ['pl', 'en'],
    ES: ['es', 'en'],
    GB: ['en'],
    UK: ['en'],
    US: ['en']
  };

  var DEFAULT_LANGUAGES = ['en'];
  // ---------------------------------------------------------------------------

  var dialog = document.getElementById('livly-locale-popup');
  if (!dialog) return;

  var form       = dialog.querySelector('#livly-locale-form');
  var countrySel = dialog.querySelector('#livly-locale-country');
  var langGroup  = dialog.querySelector('#livly-locale-langs');
  var langInput  = dialog.querySelector('#livly-locale-language-input');
  var closeBtn   = dialog.querySelector('[data-livly-locale-close]');
  var showAllBtn = dialog.querySelector('[data-livly-locale-show-all]');

  var currentCountry  = (dialog.dataset.currentCountry || '').toUpperCase();
  var currentLanguage = (dialog.dataset.currentLanguage || '').toLowerCase();

  // Store original language pills before filtering.
  var allLanguagePills = [];

  if (langGroup) {
    Array.prototype.slice.call(langGroup.querySelectorAll('.livly-locale__pill')).forEach(function (pill) {
      allLanguagePills.push(pill.cloneNode(true));
    });
  }

  // Append Langify-only languages, then store them too.
  var langifyLanguages = [];
  try {
    langifyLanguages = JSON.parse(dialog.dataset.langifyLanguages || '[]');
  } catch (e) {
    langifyLanguages = [];
  }

  langifyLanguages.forEach(function (lang) {
    if (!lang || !lang.code) return;

    var code = String(lang.code).toLowerCase();

    if (allLanguagePills.some(function (p) {
      return (p.dataset.languageCode || '').toLowerCase() === code;
    })) {
      return;
    }

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.setAttribute('role', 'radio');
    pill.className = 'livly-locale__pill';
    pill.setAttribute('aria-checked', 'false');
    pill.setAttribute('data-language-code', code);
    pill.setAttribute('data-language-source', 'langify');
    pill.textContent = lang.label || code;

    allLanguagePills.push(pill);
  });

  function baseLang(code) {
    return String(code || '').toLowerCase().split('-')[0];
  }

  function getAllowedLanguagesForCountry(countryCode) {
    var country = String(countryCode || '').toUpperCase();
    return COUNTRY_LANGUAGE_MAP[country] || DEFAULT_LANGUAGES;
  }

  function clearLanguageSelection() {
    langGroup.querySelectorAll('.livly-locale__pill').forEach(function (pill) {
      pill.classList.remove('is-selected');
      pill.setAttribute('aria-checked', 'false');
    });
  }

  function selectLanguagePill(pill) {
    if (!pill) return;

    clearLanguageSelection();

    pill.classList.add('is-selected');
    pill.setAttribute('aria-checked', 'true');

    langInput.value = pill.dataset.languageCode || 'en';
    langInput.dataset.source = pill.dataset.languageSource || 'shopify';
  }

  function renderLanguagePillsForCountry(countryCode, preferredLanguage) {
    if (!langGroup) return;

    var allowed = getAllowedLanguagesForCountry(countryCode).map(baseLang);
    var preferred = baseLang(preferredLanguage || langInput.value || currentLanguage);

    langGroup.innerHTML = '';

    var rendered = [];

    allLanguagePills.forEach(function (originalPill) {
      var code = baseLang(originalPill.dataset.languageCode);

      if (allowed.indexOf(code) === -1) return;

      var clone = originalPill.cloneNode(true);
      clone.classList.remove('is-selected');
      clone.setAttribute('aria-checked', 'false');

      langGroup.appendChild(clone);
      rendered.push(clone);
    });

    var preferredPill = rendered.find(function (pill) {
      return baseLang(pill.dataset.languageCode) === preferred;
    });

    var englishPill = rendered.find(function (pill) {
      return baseLang(pill.dataset.languageCode) === 'en';
    });

    selectLanguagePill(preferredPill || englishPill || rendered[0]);
  }

  // Initial language filtering.
  renderLanguagePillsForCountry(currentCountry, currentLanguage);

  // ---------- Cookie helpers -------------------------------------------------
  function readCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() +
      '; path=/; SameSite=Lax';
  }

  // ---------- Open / close ---------------------------------------------------
  function openDialog() {
    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (err) {
        dialog.setAttribute('open', '');
      }
    } else {
      dialog.setAttribute('open', '');
      dialog.setAttribute('data-fallback', 'true');
    }

    document.body.classList.add('livly-locale-open');

    var firstFocus = dialog.querySelector('select, button');
    if (firstFocus) firstFocus.focus();
  }

  function closeDialog() {
    if (typeof dialog.close === 'function' && dialog.open) {
      try {
        dialog.close();
      } catch (e) {
        dialog.removeAttribute('open');
      }
    } else {
      dialog.removeAttribute('open');
    }

    document.body.classList.remove('livly-locale-open');
  }

  closeBtn && closeBtn.addEventListener('click', function () {
    writeCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    closeDialog();
  });

  dialog.addEventListener('click', function (event) {
    var panel = dialog.querySelector('.livly-locale__panel');
    if (!panel) return;

    var r = panel.getBoundingClientRect();
    var x = event.clientX;
    var y = event.clientY;

    var inside = x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;

    if (!inside) {
      writeCookie(COOKIE_NAME, '1', COOKIE_DAYS);
      closeDialog();
    }
  });

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    writeCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    closeDialog();
  });

  document.querySelectorAll('[data-livly-locale-trigger]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openDialog();
    });
  });

  // ---------- View all countries --------------------------------------------
  if (showAllBtn) {
    showAllBtn.addEventListener('click', function () {
      dialog.classList.add('is-all-countries');

      var groups = countrySel.querySelectorAll('optgroup');
      groups.forEach(function (g) {
        while (g.firstChild) {
          countrySel.insertBefore(g.firstChild, g);
        }
        g.remove();
      });

      countrySel.focus();
    });
  }

  // ---------- Country change -------------------------------------------------
  countrySel && countrySel.addEventListener('change', function () {
    var code = (countrySel.value || '').toUpperCase();

    var emoji = emojiFlag(code);
    var current = dialog.querySelector('#livly-locale-flag');

    if (current) {
      emoji.id = 'livly-locale-flag';
      current.replaceWith(emoji);
    }

    renderLanguagePillsForCountry(code);
  });

  function emojiFlag(iso) {
    var span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.style.fontSize = '18px';
    span.style.lineHeight = '1';

    span.textContent = (iso || '').toUpperCase().replace(/./g, function (c) {
      return String.fromCodePoint(127397 + c.charCodeAt(0));
    });

    return span;
  }

  // ---------- Language pill selection ---------------------------------------
  langGroup.addEventListener('click', function (event) {
    var pill = event.target.closest('.livly-locale__pill');
    if (!pill) return;

    selectLanguagePill(pill);
  });

  langGroup.addEventListener('keydown', function (event) {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) return;

    var pills = Array.prototype.slice.call(langGroup.querySelectorAll('.livly-locale__pill'));
    var index = pills.indexOf(document.activeElement);

    if (index === -1) return;

    event.preventDefault();

    var next = (event.key === 'ArrowRight' || event.key === 'ArrowDown') ? index + 1 : index - 1;

    if (next < 0) next = pills.length - 1;
    if (next >= pills.length) next = 0;

    pills[next].focus();
    selectLanguagePill(pills[next]);
  });

  // ---------- Submit handling -----------------------------------------------
  form.addEventListener('submit', function (event) {
    var chosenCountry  = (countrySel.value || '').toUpperCase();
    var chosenLanguage = (langInput.value || '').toLowerCase();
    var source         = langInput.dataset.source || 'shopify';

    writeCookie(COOKIE_NAME, '1', COOKIE_DAYS);

    if (chosenCountry === currentCountry && chosenLanguage === currentLanguage && source === 'shopify') {
      event.preventDefault();
      closeDialog();
      return;
    }

    if (source === 'langify') {
      event.preventDefault();
      submitCountryThenLangify(chosenCountry, chosenLanguage);
      return;
    }
  });

  function submitCountryThenLangify(country, language) {
    var fd = new FormData(form);

    var firstShopifyPill = langGroup.querySelector('[data-language-source="shopify"]');

    fd.set('language_code', firstShopifyPill ? firstShopifyPill.dataset.languageCode : currentLanguage);
    fd.set('country_code', country);

    fetch('/localization', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'text/html' },
      credentials: 'same-origin'
    }).then(function () {
      handLangifyOff(language);
    }).catch(function () {
      handLangifyOff(language);
    });
  }

  function handLangifyOff(language) {
    if (LANGIFY_MODE === 'auto' || LANGIFY_MODE === 'js') {
      var api = window.langify || window.Langify;

      if (api && typeof api.setLanguage === 'function') {
        try {
          api.setLanguage(language);
          return;
        } catch (e) {}
      }
    }

    var url = window.location.href;

    if (LANGIFY_MODE === 'path') {
      var u = new URL(url);
      var segs = u.pathname.split('/').filter(Boolean);

      if (segs[0] && /^[a-z]{2}(-[a-z]{2})?$/i.test(segs[0])) segs.shift();

      u.pathname = '/' + language + '/' + segs.join('/');
      window.location.href = u.toString();
      return;
    }

    if (LANGIFY_MODE === 'param' || LANGIFY_MODE === 'auto') {
      var pu = new URL(url);
      pu.searchParams.set(LANGIFY_PARAM, language);
      window.location.href = pu.toString();
      return;
    }

    if ((LANGIFY_MODE === 'subdomain' || LANGIFY_MODE === 'domain') && LANGIFY_DOMAINS[language]) {
      var target = new URL(url);
      target.host = LANGIFY_DOMAINS[language];
      window.location.href = target.toString();
      return;
    }

    window.location.reload();
  }

  // ---------- Auto-open on first visit + mismatch ----------------------------
  function shouldAutoOpen(suggestedCountry) {
    if (readCookie(COOKIE_NAME)) return false;
    if (!suggestedCountry) return false;

    return suggestedCountry.toUpperCase() !== currentCountry;
  }

  function preselect(suggestedCountry, suggestedLanguage) {
    if (suggestedCountry) {
      var iso = suggestedCountry.toUpperCase();

      if (countrySel && countrySel.querySelector('option[value="' + iso + '"]')) {
        countrySel.value = iso;
        countrySel.dispatchEvent(new Event('change'));
      }
    }

    if (suggestedLanguage) {
      renderLanguagePillsForCountry(countrySel.value || currentCountry, suggestedLanguage);
    }
  }

  function fetchSuggestion() {
    return fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      return r.json();
    }).catch(function () {
      return null;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchSuggestion().then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country;
      var iso = detected && (detected.handle || detected.iso_code);

      var detectedLang = data && data.detected_values && data.detected_values.language &&
        (data.detected_values.language.handle || data.detected_values.language.iso_code);

      if (shouldAutoOpen(iso)) {
        preselect(iso, detectedLang);
        openDialog();
      }
    });
  });
})();